export default __webpack_public_path__ + "2e0a90da2a2626942373d6c13ee7d549.png";